import { StartQueryActionCreatorOptions } from '@reduxjs/toolkit/dist/query/core/buildInitiate';

import { getEndpointByName } from 'store/utils/getEndpointByName';

import { TFAQueryFnParams } from '../types';
import { getTFARefetchFixedCacheKey } from './getTFARefetchFixedCacheKey';

const isTFAParams = (params: unknown): params is TFAQueryFnParams<unknown> =>
  typeof params === 'object' && params !== null && 'params' in params;

const getParams = (
  params: unknown,
  totp: string,
): TFAQueryFnParams<unknown> => {
  if (isTFAParams(params)) {
    return {
      params: params.params,
      totp,
    };
  }

  return { params, totp };
};

export interface ICallEndpointParams {
  endpointName: string;
  params: unknown;
  totp: string;
}

export const callEndpoint = ({
  endpointName,
  params,
  totp,
}: ICallEndpointParams) => {
  const endpoint = getEndpointByName(endpointName);

  return endpoint.initiate(getParams(params, totp), {
    fixedCacheKey: getTFARefetchFixedCacheKey(endpoint.name),
  } as unknown as StartQueryActionCreatorOptions);
};
